/** The one status -> Tag colour map, see StatusTag. */
export type StatusTagType = 'green' | 'red' | 'blue' | 'purple' | 'gray';

const STATUS_TYPE: Record<string, StatusTagType> = {
  paid: 'green',
  // An order's statuses (ADR 0088): completed, handed over and served are done; partly paid or sent and waiting are in progress;
  // overpaid needs a refund.
  completed: 'green',
  handed_over: 'green',
  served: 'green',
  partially_paid: 'blue',
  partially_sent: 'blue',
  waiting: 'blue',
  out_for_delivery: 'blue',
  overpaid: 'purple',
  approved: 'green',
  delivered: 'green',
  payment: 'green',
  active: 'green',
  // Kitchen tickets, print jobs and printers (ADR 0027).
  printed: 'green',
  online: 'green',
  ready: 'green',
  bumped: 'green',
  // E-invoices (ADR 0048): issued is done; being sent or looked up is in progress; no profile yet needs attention.
  issued: 'green',
  submitting: 'blue',
  uncertain: 'blue',
  awaiting_number: 'blue',
  not_configured: 'purple',
  voided: 'red',
  failed: 'red',
  offline: 'red',
  error: 'red',
  declined: 'red',
  no_driver: 'red',
  open: 'blue',
  sent: 'blue',
  pending: 'blue',
  queued: 'blue',
  printing: 'blue',
  in_progress: 'blue',
  bill_printed: 'purple',
  awaiting: 'purple', // waiting for someone else: a store's answer, a customer's payment
  cancel_requested: 'purple',
  refund: 'purple',
  recalled: 'purple',
  // Neutral: finished without a result, or nothing has happened yet.
  merged: 'gray',
  cancelled: 'gray',
  returned: 'gray',
  new: 'gray',
};

export const statusTagType = (status: string): StatusTagType => STATUS_TYPE[status] ?? 'gray';
